import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { SelectModule } from 'primeng/select';
import { AuthenticationService } from '../../services/authentication.service';
import { InputOtpModule } from 'primeng/inputotp';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-email-verification-screen',
  imports: [
    CommonModule,
    FormsModule,
    FloatLabelModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    TranslocoDirective,
    SelectModule,
    InputOtpModule,
    TooltipModule
  ],
  templateUrl: './email-verification-screen.component.html',
  styleUrl: './email-verification-screen.component.scss'
})
export class EmailVerificationScreenComponent {

  subtitleParams: any = {
    email: this.authService.getCurrentUser().email
  }
  otp: string = ""


  constructor(
    private authService: AuthenticationService
  ) {
  }

  requestNewVerificationEmail() {
    this.authService.requestNewVerificationEmail();
    this.otp = "";
  }

  verifyEmail() {
    if (this.otp.length != 6) {
      return;
    }
    this.authService.verifyEmail(this.otp);
  }

  logout() {
    this.authService.logout(true);
  }
}
